import React from "react";
import { CheckIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  color?: string;
  onDark?: boolean;
  columns?: boolean;
};
export function CheckList({
  items,
  color = "#1F6FEB",
  onDark = false,
  columns = false
}: CheckListProps) {
  return <ul className={`grid gap-3 ${columns ? "md:grid-cols-2 md:gap-x-8" : ""}`} data-id="element-21" data-mp="3cr3tn03tjkfq">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="33ob4b2e75isj">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
        backgroundColor: color
      }} data-id="element-23" data-mp="33pvy2psosxpc">
            <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-24" data-mp="2tzt8z0oos3wa" />
          </span>
          <span className={`text-base leading-snug ${onDark ? "text-white/90" : "text-ink"}`} data-id="element-25" data-mp="2p0zt51lxg0sy">{item}</span>
        </li>)}
    </ul>;
}